import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { ReviewPayload } from './faq.mutation';
import { FaqParams, Inquiry, InquiryDetails, InquiryDetailsParams, RatingsPreview, ReviewAndRating } from './faq.types';

const getReviewsAndRating = (client: AxiosInstance) => async (params?: FaqParams) => {
  return (
    await client.get<PaginatedApiResponse<ReviewAndRating[]>>(API_ROUTES.GET_REVIEW_AND_RATINGS, {
      params,
    })
  ).data;
};

const getReviewDetails = (client: AxiosInstance) => async (payload: ReviewPayload) => {
  return (
    await client.get<PaginatedApiResponse<RatingsPreview>>(API_ROUTES.GET_RETINGS_PREVIEW, {
      params: { reviewId: payload.reviewId },
    })
  ).data;
};

const getInquiries = (client: AxiosInstance) => async (params?: FaqParams) => {
  return (
    await client.get<PaginatedApiResponse<Inquiry[]>>(API_ROUTES.GET_INQUIRY, {
      params,
    })
  ).data;
};

const getInquiryDetails = (client: AxiosInstance) => async (params?: InquiryDetailsParams) => {
  return (
    await client.get<ApiResponse<InquiryDetails>>(API_ROUTES.GET_INQUIRY_DETAILS, {
      params,
    })
  ).data;
};

const getComplaints = (client: AxiosInstance) => async (params?: FaqParams) => {
  return (
    await client.get<PaginatedApiResponse<Inquiry[]>>(API_ROUTES.GET_COMPLAINTS, {
      params,
    })
  ).data;
};

export const faqQueries = {
  all: () => ['faqs'],
  reviewAndRatings: (params: FaqParams) =>
    queryFactoryOptions<PaginatedApiResponse<ReviewAndRating[]>>({
      queryKey: [...faqQueries.all(), 'review-and-ratings', params],
      queryFn: (client) => () => getReviewsAndRating(client)(params),
    }),
  ratingsPreview: (payload: ReviewPayload) =>
    queryFactoryOptions<PaginatedApiResponse<RatingsPreview>>({
      queryKey: [...faqQueries.all(), 'review-details', payload.reviewId],
      queryFn: (client) => () => getReviewDetails(client)(payload),
    }),
  inquiry: (params?: FaqParams) =>
    queryFactoryOptions<PaginatedApiResponse<Inquiry[]>>({
      queryKey: [...faqQueries.all(), 'inquiry', params],
      queryFn: (client: AxiosInstance) => () => getInquiries(client)(params),
    }),
  inquiryDetails: (params?: InquiryDetailsParams) =>
    queryFactoryOptions<ApiResponse<InquiryDetails>>({
      queryKey: [...faqQueries.all(), 'inquiryDetails', params],
      queryFn: (client: AxiosInstance) => () => getInquiryDetails(client)(params),
    }),
  complaints: (params: FaqParams) =>
    queryFactoryOptions<PaginatedApiResponse<Inquiry[]>>({
      queryKey: [...faqQueries.all(), 'complaints', params],
      queryFn: (client) => () => getComplaints(client)(params),
    }),
};
